import TopBar from "@/pages/home/components/TopBar";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import UpdateLog from "@/pages/home/components/UpdateLog";
import ReasonsSection from "@/pages/home/components/ReasonsSection";
import SolutionsSection from "@/pages/home/components/SolutionsSection";
import DomainCheckSection from "@/pages/home/components/DomainCheckSection";
import PermanentEntrySection from "@/pages/home/components/PermanentEntrySection";
import WhereToLookSection from "@/pages/home/components/WhereToLookSection";
import GlossarySection from "@/pages/home/components/GlossarySection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-sans text-foreground-900">
      <TopBar />
      <Navbar />
      <main>
        <Hero />
        <UpdateLog />
        <ReasonsSection />
        <SolutionsSection />
        <DomainCheckSection />
        <PermanentEntrySection />
        <WhereToLookSection />
        <GlossarySection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}